module.exports = __webpack_public_path__ + "img/cus_hover11.4199be1e.png";